import script from "./sf-comment.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-comment.vue?vue&type=script&setup=true&lang=ts"

import "./sf-comment.vue?vue&type=style&index=0&id=df4429f3&lang=scss"

const __exports__ = script;

export default __exports__